import { LongSleeveQuarterZipSizeGraphic, ShortSleevePoloSizeGraphic, ShortSleeveTeeShirtSizeGraphic } from "../svgs";

const SIZE_ORDER = ["XS", "S", "M", "L", "XL", "XXL"];

const DEFAULT_MEASUREMENTS = ["chest", "waist", "length", "sleeve"];

const MEASUREMENT_LABELS = {
  chest: "Chest",
  waist: "Waist",
  length: "Length",
  sleeve: "Sleeve",
};

const SIZE_CHART_GRAPHICS_BY_TYPE = {
  "short-sleeve-tee-shirt": ShortSleeveTeeShirtSizeGraphic,
  "short-sleeve-polo": ShortSleevePoloSizeGraphic,
  "long-sleeve-quarter-zip": LongSleeveQuarterZipSizeGraphic,
};

const DEFAULT_SIZE_CHART_INFO =
  'All measurements are taken with the garment laid flat. Chest is measured 1" below the armhole from side to side, length is measured from the high point shoulder (HPS) to the bottom hem, and sleeve is measured from the shoulder seam to the sleeve opening. Measurements may vary slightly due to the manufacturing process. Our tees are designed with a proportional fit intended to provide a clean, tailored look without excessive length or oversized proportions.';

const getSizeChartSizes = (sizeChart = {}) => sizeChart.sizes || sizeChart;

const getMeasurements = (sizeChart = {}) => {
  if (Array.isArray(sizeChart.measurements) && sizeChart.measurements.length) {
    return sizeChart.measurements;
  }

  const sizes = getSizeChartSizes(sizeChart);
  const firstSizeWithValues = SIZE_ORDER.map((size) => sizes?.[size]).find(Boolean);

  if (!firstSizeWithValues) return DEFAULT_MEASUREMENTS;

  const availableMeasurements = DEFAULT_MEASUREMENTS.filter((measurement) => firstSizeWithValues[measurement] !== undefined);

  return availableMeasurements.length ? availableMeasurements : DEFAULT_MEASUREMENTS;
};

const formatMeasurementLabel = (measurement) => MEASUREMENT_LABELS[measurement] || measurement;

const SizeChart = ({ product }) => {
  const sizeChart = product?.sizeChart || {};
  const sizes = getSizeChartSizes(sizeChart);
  const measurements = getMeasurements(sizeChart);
  const Graphic = SIZE_CHART_GRAPHICS_BY_TYPE[sizeChart.type] || ShortSleeveTeeShirtSizeGraphic;
  const infoText = sizeChart.infoText || DEFAULT_SIZE_CHART_INFO;

  return (
    <div className="size-guide">
      <div className="shirt-size-graphic">
        <Graphic />
      </div>

      <div className="size-chart">
        <div className="size-chart-border">
          <table className="size-chart-table" width="100%" border="0" cellSpacing="0" cellPadding="0">
            <tbody>
              <tr>
                <td className="size-type-label"></td>
                {measurements.map((measurement) => (
                  <td key={measurement} className="size-type-label">
                    {formatMeasurementLabel(measurement)}
                  </td>
                ))}
              </tr>

              {SIZE_ORDER.map((size) => (
                <tr key={size}>
                  <td className="size-label">{size}</td>
                  {measurements.map((measurement) => (
                    <td key={`${size}-${measurement}`}>{sizes?.[size]?.[measurement] || "-"}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="size-chart-bottom">Shirt dimensions are in inches</div>
      </div>

      <div className="size-chart-info">{infoText}</div>
    </div>
  );
};

export default SizeChart;
